import { useState, useMemo } from 'react';
import { compareValues } from '../utils/sort';

// Ordenação client-side por coluna: 1º clique asc, 2º desc, 3º volta à ordem
// original. accessors ({ chave: (row) => valor }) deve ser constante de módulo
// para não invalidar o memo a cada render.
export const useTableSort = (rows, accessors) => {
  const [sort, setSort] = useState({ key: null, dir: 'asc' });

  const toggleSort = (key) => {
    setSort((prev) => {
      if (prev.key !== key) return { key, dir: 'asc' };
      if (prev.dir === 'asc') return { key, dir: 'desc' };
      return { key: null, dir: 'asc' };
    });
  };

  const sorted = useMemo(() => {
    const accessor = sort.key ? accessors[sort.key] : null;
    if (!accessor) return rows;
    const arr = [...rows].sort((a, b) => compareValues(accessor(a), accessor(b)));
    if (sort.dir === 'desc') arr.reverse();
    return arr;
  }, [rows, sort, accessors]);

  return { sorted, sort, toggleSort };
};
